import Web3 from 'web3';

import {
  NETWORKS
} from "../utils/networks.js"

import {
  store
} from "../store/index"

import config from "./config.json";

export async function startWeb3Checks() {
  checkAccountsAndNetwork();
  setInterval(checkAccountsAndNetwork, config.pollingInterval1s);
}

async function checkAccountsAndNetwork() {
  let web3Object = store.state.web3;
  if (web3Object.connected) {
    let web3 = web3Object.web3Instance;
    let accounts = await web3.eth.getAccounts();
    let networkId = await web3.eth.net.getId();
    let networkString = NETWORKS[networkId];
    web3Object.networkId = networkId;
    if (accounts.length > 0) {
      let balance = await web3.eth.getBalance(accounts[0]);
      web3Object.account = accounts[0];
      web3Object.networkId = networkId;
      web3Object.networkString = networkString;
      web3Object.balance = web3.utils.fromWei(balance);
    } else {
      web3Object = {
        connected: false,
        web3Instance: null,
        networkId: null,
        networkString: null,
        account: null,
        balance: null,
      };
    }
    store.commit("SET_WEB3OBJECT", web3Object);
  }
}

export async function connectWeb3() {
  let provider = null;
  let web3 = null;
  if (window.ethereum) {
    provider = window.ethereum;
    try {
      await window.ethereum.request({
        method: 'eth_requestAccounts'
      });
    } catch (error) {
      console.log("User denied account access");
    }
  } else if (window.web3) {
    provider = window.web3.currentProvider;
  } else {
    provider = new Web3.providers.HttpProvider("http://127.0.0.1:7545");
  }
  web3 = new Web3(provider);

  const connected = true;
  const networkId = await web3.eth.net.getId();
  const networkString = NETWORKS[networkId];
  const accounts = await web3.eth.getAccounts();
  const balance = await web3.eth.getBalance(accounts[0]);

  let web3Object = {
    connected: connected,
    web3Instance: web3,
    networkId: networkId,
    networkString: networkString,
    account: accounts[0],
    balance: web3.utils.fromWei(balance),
  };

  store.commit("SET_WEB3OBJECT", web3Object);
}
